import { render } from "./FeaturesList.vue?vue&type=template&id=792f25e5&scoped=true"
import script from "./FeaturesList.vue?vue&type=script&lang=js"
export * from "./FeaturesList.vue?vue&type=script&lang=js"

import "./FeaturesList.vue?vue&type=style&index=0&id=792f25e5&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/simple-city-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792f25e5"]])

export default __exports__